import styled from 'astroturf/react'
import { Loader } from '@calendly/ui/components/loader'
import _Container from "loader-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/routing_form/loader.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

export const CenteredLoader = () => (
  <Container>
    <Loader />
  </Container>
)
